// extracted by mini-css-extract-plugin
export var iconContainer = "_fg-0";
export var metricCardsContainer = "_fg-1";